<template xmlns:v-images-loaded="http://www.w3.org/1999/xhtml">
  <div v-images-loaded:on.progress="imageProgress">
    <div v-masonry gutter="15" transition-duration="0s" item-selector=".item">
      <div v-bind:key="index" v-masonry-tile class="item" v-for="(thing, index) in things">
        <card class="border-0 mb-3 masonry-item" no-body shadow>

          <img class="img-fluid"
               :src="thing.default_image.sizes[13].url">
          <div class="px-3 mt-3 pb-3">
            <!--<icon :name="{ prefix: 'far', iconName: 'comments' }" type="primary" rounded-->
            <!--class="mb-4">-->
            <!--</icon>-->
            <badge type="primary mb-3" rounded>{{thing.date | formatDate}}</badge>
            <badge type="orange mb-3" rounded>{{thing.creator.name}}</badge>

            <h6 class="text-primary text-uppercase">{{thing.name}}</h6>
            <p class="description mt-3">{{thing.description | shorten}}</p>

            <div class="d-block">
              <badge type="thingiverse" rounded>{{thing.like_count}}
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'thumbs-up' }"/>
              </badge>
              <badge type="thingiverse" rounded>{{thing.download_count}}
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'download' }"/>
              </badge>
              <badge type="thingiverse" rounded>{{thing.view_count}}
                <font-awesome-icon :icon="{ prefix: 'fas', iconName: 'eye' }"/>
              </badge>
            </div>

            <base-button tag="a" :href="thing.public_url" target="_blank" type="primary"
                         class="mt-4 shadow text-white">
              Check it out
            </base-button>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import imagesLoaded from 'vue-images-loaded'
import moment from 'moment'

export default {
  name: 'repositories-masonry',
  directives: {
    imagesLoaded
  },
  methods: {
    imageProgress (instance, image) {
      return image.isLoaded ? 'loaded' : 'broken'
    }
  },
  filters: {
    shorten (description) {
      description = description.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '')
      let div = document.createElement('div')
      div.innerHTML = description
      description = div.textContent || div.innerText || ''
      return description.substring(0, 250)
    },
    formatDate (date) {
      return moment(date).format('D-MMM-YY')
    }
  },
  props: ['things']
}
</script>
<style>
  .masonry-item {
    width: 21.5rem
  }

  @media (max-width: 768px) {
    .masonry-item {
      width: 100%

    }
  }
</style>
